__turbopack_context__.v({
  "main": "CompanyView-module__9ieGzW__main",
  "page": "CompanyView-module__9ieGzW__page",
  "staffContainer": "CompanyView-module__9ieGzW__staffContainer",
  "staffSection": "CompanyView-module__9ieGzW__staffSection",
});
